<div class="editable-parameter-wrapper Flexbox results-pane-item Marginbox__r-medium" (deepBlur)="onInputBlur(this)"
     (genOutsideClick)="onInputBlur($event)"
     [attachOutsideOnClick]="true"
     [excludeBeforeClick]="true"
     [exclude]="clicksExcluded"
     [ngClass]="{'required-invalid-value':invalid, 'required':required, 'hide-edit-icon':hideEditIcon, 'Marginbox__r-medium': !ignoreMarginRight}">
  <section style="display: none;">
    <span #parser></span>
  </section>
  <gen-invalid-tooltip *ngIf="displayTooltip" [tooltipPlacement]="'right'" [tooltipRequired]="invalid"
                       [tooltipText]="title+' Required'" [ngClass]="tooltipWrapperClass" class="invalid-tooltip-wrapper"></gen-invalid-tooltip>
  <span class="results-pane-caption" *ngIf="title">{{title}}</span>
  <div [ngClass]="{'results-pane-value-edit-mode':isEditableField,'hidden':editable && !readOnlyView, 'prompt-separator': promptSeparator}"
       class="Flexbox results-pane-value-border"
       (click)="Edit(false,true)">
    <div [ngStyle]="valueStyle" class="results-pane-value">
      <ng-container [ngSwitch]="handler">
        <ng-container *ngSwitchCase="'array'">
          <ng-container *ngFor="let val of value">
            <ng-container *ngTemplateOutlet="TextualContent;context:{value:val,resourceFieldConfig:resourceFieldConfig,cssClass:val.cssClass}"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <ng-container *ngTemplateOutlet="TextualContent;context:{value:value,resourceFieldConfig:resourceFieldConfig}"></ng-container>
        </ng-container>
      </ng-container>
    </div>
    <span *ngIf="needShowEmptyText(value)" class="edit-no-text">{{editableItemEmptyValueText | stringTranslate}}</span>
    <i class="results-pane-required" *ngIf="showRequiredMark()" style="margin-left: 8px"></i>
    <span *ngIf="isEditableField" class="glyphicon glyphicon-pencil pointer edit-icon" [ngClass]="{'visible-pencil':getResourceFieldType() === 'text-with-link'}"></span>
  </div>
  <div [ngClass]="{'hidden':!editable || readOnlyView}" class="Flexbox__flex-1 {{classes}}">
    <ng-content></ng-content>
    <i class="results-pane-required" *ngIf="showRequiredMark()" style="right: 24px;"></i>
  </div>
</div>
<ng-template #TextualContent
             let-resourceFieldConfig="resourceFieldConfig"
             let-value="value"
             let-cssClass="cssClass"
>
  <gen-textual-content
    [showTitle]="false"
    [fieldConfig]="resourceFieldConfig"
    [item]="value"
    [ngClass]="cssClass"
    class="AUTO_VALUE_WRAPPER"
    (linkClick)="linkClicked($event)"
    [tooltipText]="tooltipText"
    [tooltipConfiguration]="tooltipConfiguration"
    [tooltipPosition]="tooltipPosition"
    [tooltipData]="tooltipData"
    [icon]="icon"
    [fieldType]="fieldType"
    [fieldAttributes]="fieldAttributes"
    [isItDefault]="isItDefault"
  ></gen-textual-content>
</ng-template>
